import theme,{colorPalatte} from './theme';

export default theme;
export {colorPalatte};
